<div class="profile-completion--wrapper">
	<div
		#titleWrapperDiv
		(click)="showTodos()"
		class="profile-completion--body--title-wrapper"
	>
		<div class="profile-completion--body--title-text disable-select">
			<div [innerHTML]="title"></div>
		</div>
		<div #dropdownImage class="profile-completion--icon-chevron">
			<fa-icon *ngIf="showDropdown" icon="chevron-down"></fa-icon>
		</div>
	</div>

	<h5 [innerHTML]="subtitle"></h5>

	<div #todoContentDiv class="todo-content">
		<div *ngFor="let todo of todos" class="todo-wrapper">
			<img
				alt=""
				[ngClass]="
					todo.completed
						? 'profile-completion--icon profile-completion--icon-check'
						: 'profile-completion--icon profile-completion--icon-alert'
				"
				[src]="
					todo.completed
						? '/assets/images/icons/check.svg'
						: '/assets/images/icons/alert2.svg'
				"
			/>
			<a
				class="todo"
				[ngClass]="
					todo.completed ? 'todo todo--complete' : 'todo todo--incomplete'
				"
				[href]="todo.link || '#'"
				[target]="todo.external ? '_blank' : '_self'"
				[ngStyle]="{ 'pointer-events': todo.link ? 'initial' : 'none' }"
			>
				<div>{{ todo.text }}</div>
				<img
					*ngIf="!todo.completed"
					[src]="'/assets/images/icons/arrow-right.svg'"
					class="profile-completion--icon-proceed"
					alt=""
				/>
			</a>
		</div>

		<div class="todo-footer" *ngIf="type === 'performSessions'">
			<img
				[ngClass]="'profile-completion--icon profile-completion--icon-inbox'"
				[src]="'/assets/images/icons/inbox.svg'"
				alt=""
			/>

			<a
				href="{{
					'PAGES.ACCOUNT.PROFILE__COMPLETION.PERFORM__SESSIONS.DESCRIPTION.URL'
						| translate
				}}"
				target="_blank"
				rel="noopener"
			>
				{{
					'PAGES.ACCOUNT.PROFILE__COMPLETION.PERFORM__SESSIONS.DESCRIPTION.TEXT'
						| translate
				}}
			</a>
		</div>
	</div>
</div>
